import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as cursadasService from '../../services/cursadas/cursadasService';
import {
  classifyCursadasError,
  toGenerarCursadasPayload,
  validateGenerarCursadasDates
} from '../../services/cursadas/cursadasDto';
import { todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';


export class GenerarCursadas extends Component {
  static displayName = GenerarCursadas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      code: "",
      name: "",
      anioDictado: "",
      dictado: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      startDateAnual: todayCalendarDate(),
      endDateAnual: todayCalendarDate(),
      startDate1C: todayCalendarDate(),
      endDate1C: todayCalendarDate(),
      startDate2C: todayCalendarDate(),
      endDate2C: todayCalendarDate(),
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleStartDateAnual = this.handleStartDateAnual.bind(this);
    this.handleEndDateAnual = this.handleEndDateAnual.bind(this);
    this.handleStartDate1C = this.handleStartDate1C.bind(this);
    this.handleEndDate1C = this.handleEndDate1C.bind(this);
    this.handleStartDate2C = this.handleStartDate2C.bind(this);
    this.handleEndDate2C = this.handleEndDate2C.bind(this);
  }

  handleConfirmButton = () => {
    const okToSave = validateGenerarCursadasDates({
      startDateAnual: this.state.startDateAnual,
      endDateAnual: this.state.endDateAnual,
      startDate1C: this.state.startDate1C,
      endDate1C: this.state.endDate1C,
      startDate2C: this.state.startDate2C,
      endDate2C: this.state.endDate2C
    });

    if (okToSave) {
      this.saveStudent();
    } else {
      this.setState({ showErrorMessage: true, errorMessage: "Revise las fechas ingresadas" });
    }
  }

  async componentDidMount() {
    await constantClass.canAccess('WWCursada');
  }

  handleStartDateAnual = (date) => {
    this.setState({ startDateAnual: date });
  }

  handleEndDateAnual = (date) => {
    this.setState({ endDateAnual: date });
  }

  handleStartDate1C = (date) => {
    this.setState({ startDate1C: date });
  }

  handleEndDate1C = (date) => {
    this.setState({ endDate1C: date });
  }

  handleStartDate2C = (date) => {
    this.setState({ startDate2C: date });
  }

  handleEndDate2C = (date) => {
    this.setState({ endDate2C: date });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-cur" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-generar-cursadas">
        <Link className="md-page__back-link" to="/md-cur">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Generar Cursadas</h1>
        </div>
        <p className="md-page__subtitle">
          Defina las fechas de inscripción para cada período de cursada.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Período anual</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-anual-inicio">
                  Inicio de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-anual-inicio"
                  className="md-page__field-input"
                  selected={this.state.startDateAnual}
                  onChange={this.handleStartDateAnual}
                  disabled={loading}
                />
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-anual-fin">
                  Fin de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-anual-fin"
                  className="md-page__field-input"
                  selected={this.state.endDateAnual}
                  onChange={this.handleEndDateAnual}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Primer cuatrimestre</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-1c-inicio">
                  Inicio de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-1c-inicio"
                  className="md-page__field-input"
                  selected={this.state.startDate1C}
                  onChange={this.handleStartDate1C}
                  disabled={loading}
                />
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-1c-fin">
                  Fin de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-1c-fin"
                  className="md-page__field-input"
                  selected={this.state.endDate1C}
                  onChange={this.handleEndDate1C}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Segundo cuatrimestre</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-2c-inicio">
                  Inicio de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-2c-inicio"
                  className="md-page__field-input"
                  selected={this.state.startDate2C}
                  onChange={this.handleStartDate2C}
                  disabled={loading}
                />
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="gen-cur-2c-fin">
                  Fin de inscripción
                </label>
                <CalendarDatePicker
                  inputId="gen-cur-2c-fin"
                  className="md-page__field-input"
                  selected={this.state.endDate2C}
                  onChange={this.handleEndDate2C}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await cursadasService.generarCursadas(
        toGenerarCursadasPayload({
          startDateAnual: this.state.startDateAnual,
          endDateAnual: this.state.endDateAnual,
          startDate1C: this.state.startDate1C,
          endDate1C: this.state.endDate1C,
          startDate2C: this.state.startDate2C,
          endDate2C: this.state.endDate2C
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCursadasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
